<template>
  <div>
    <el-container class="container-app" >
      <el-header class="homeHeader" style="height: 64px">
        <div class="title">云擎协同办公平台</div>
        <div>
          <div class="msg-box" @click="goChat()">
            <el-button
              icon="el-icon-bell"
              type="text"
              size="normal"
              style="color: blueviolet; margin-right: 20px"
            ></el-button>
            <el-badge v-if="msgTotal != 0" :value="msgTotal" class="msg-badge">
            </el-badge>
          </div>
          <!-- 放头像以及下拉框 -->
          <el-dropdown class="userInfo" @command="commandHandler">
            <span class="el-dropdown-link">
              <span class="uname"> {{ user.trueName }} </span>
              <i><img :src="user.userFace" style="vertical-align: middle" /></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="userinfo">个人中心</el-dropdown-item>
              <!-- <el-dropdown-item command="setting">设置</el-dropdown-item> -->
              <el-dropdown-item command="logout">注销登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 放头像以及下拉框 -->
        </div>
      </el-header>
      <el-container style="height: calc(100vh - 64px); overflow: hidden">
        <!-- <el-aside width="200px" style="background: #333744; height: 700px;"> -->
        <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px">
          <el-radio-button :label="false">展开</el-radio-button>
          <el-radio-button :label="true">收起</el-radio-button>
        </el-radio-group> -->
        <el-aside width="collapse" style="background: #eef2f5; height: 100%">
          <el-menu
            router
            unique-opened
            background-color="#eef2f5"
            text-color="#343c3e"
            :default-active="$route.path"
            :collapse="isCollapse"
            class="el-menu-vertical-demo"
            :collapse-transition="false"
          >
            <el-submenu
              :index="index + ''"
              v-for="(item, index) in routes"
              :key="index"
            >
              <template slot="title">
                <i
                  :class="item.iconCls"
                  style="color: #343c3e; margin-right: 5px"
                  v-if="item.iconCls?.substring(0, 2) == 'fa'"
                ></i>
                <!-- <svg-icon
                  :icon-class="item.iconCls + ''"
                  v-else
                  style="margin-right: 6px"
                /> -->
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item
                :index="children.path"
                v-for="(children, indexj) in item.children"
                :key="indexj"
              >
                {{ children.name }}
              </el-menu-item>
              
              
            </el-submenu>

          </el-menu>
          
        </el-aside>
        <el-main style="padding: 0 20px; overflow-y: auto">
          <div class="breadcrumb-box">
            <!-- 不是首页，需要显示面包绡 -->
            <svg
              :class="{ 'is-active': isActive }"
              class="hamburger"
              viewBox="0 0 1024 1024"
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              @click="toggleClick"
            >
              <path
                d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
              />
            </svg>

            <el-breadcrumb
              separator-class="el-icon-arrow-right"
              v-if="this.$router.currentRoute.path != '/home'"
              class="breadcrumb-text"
            >
              <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
              >
              <el-breadcrumb-item>{{
                this.$router.currentRoute.name
              }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>

          <!-- 是首页 -->
          <div
            class="homeWelcome"
            v-if="this.$router.currentRoute.path == '/home'"
          >

            <!-- 欢迎来到云擎协同办公平台！ -->
            <template>
              <home-Page v-if="msgTotal !== '无'" :msgTotal="msgTotal"></home-Page>
            </template>
          </div>
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import homePage from "./homePage.vue";
import { pageCurrentUser } from "@/api/chat";
import { EventBus } from "@/utils/event-bus.js";

export default {
  name: "Home",
  components: {
    homePage,
  },
  data() {
    return {
      // user: JSON.parse(window.sessionStorage.getItem('user'))  //静态的
      isCollapse: false,
      isActive: false,
      msgTotal: '无',
      from: {
        limit: 999,
        page: 1,
        condition: {
          receiveStatus: false,
        },
        orders: [
          {
            asc: true,
            column: "createTime",
          },
        ],
      },
    };
  },
  created(){
    
  },
  mounted(){
   
  },
  computed: {
    routes() {
      return this.$store.state.routes; 
    },
    user() {
      return this.$store.state.currentUser; // 动态的 获取vuex中的user 对象
    },
  },
  created() {
    this.getUser();
  },
  mounted() {
    EventBus.$on("call-b-method", this.getUser);
    EventBus.$on("refresh-menu", this.reloadMenu); // 监听刷新菜单事件
  },
  beforeDestroy() {
    EventBus.$off("call-b-method", this.getUser);
    EventBus.$off("refresh-menu", this.reloadMenu);
  },
  methods: {
    reloadMenu() {
      // 可根据项目改为调用侧栏组件的刷新方法或重新拉取路由数据
      location.reload();
    },
    //获取用户消息数量
    async getUser() {
      let res = await pageCurrentUser(this.from);
      this.msgTotal = res.data.total;
    },
    // 侧边栏展开收起
    toggleClick() {
      this.isCollapse = !this.isCollapse;
      this.isActive = !this.isActive;
    },
    goChat() {
      this.$router.push("/chat");
    },
    commandHandler(command) {
      if (command == "logout") {
        this.$confirm("此操作将注销登录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            // 注销登录
            // this.postRequest('/logout'); // 可以屏蔽因为后端不做处理
            // 清空用户信息
            window.sessionStorage.clear();
            //清空菜单
            this.$store.commit("initRoutes", []);
            //跳转到登录页
            this.$router.replace("/");
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      }
      if (command == "userinfo") {
        this.$router.push("/userinfo");
      }
    },
  },
};
</script>

<style>
.container-app {
  height: 100vh;
}
.homeHeader {
  background: #409eff;
   /* background: #00ffff; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
}

.homeHeader .title {
  font-size: 30px;
  font-family: 华文楷体;
  color: white;
  /* color:darkblue */
}

.homeHeader .userInfo {
  cursor: pointer;
}

.msg-box {
  display: inline-block;
  position: relative;
}
.msg-badge {
  position: absolute !important;
  top: 0;
  right: 0;
}
.uname {
  color: white;
  margin-bottom: 28px;
  margin-left: 8px;
}

.el-dropdown-link img {
  width: 36px;
  height: 36px;
  border-radius: 24px;
  margin-left: 8px;
}

.homeWelcome {
  text-align: center;
  font-size: 30px;
  font-family: 华文楷体;
  color: #409eff;
  /* padding-top: 50px; */
}

.homeRouterView {
  margin-top: 10px;
}
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.breadcrumb-box {
  margin: 20px 0;
  display: flex;
}
.el-menu-vertical-demo {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.hamburger.is-active {
  transform: rotate(180deg);
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>
